import PropTypes from 'prop-types'

const ListMobileScrollItem = ({children}) => {
  return <li className="mt-ListMobileScroll-item">{children}</li>
}

ListMobileScrollItem.displayName = 'ListMobileScrollItem'

ListMobileScrollItem.propTypes = {
  children: PropTypes.node.isRequired
}

export default ListMobileScrollItem
